'use client'

import { cn } from 'app/lib/utils'
import { usePathname } from 'next/navigation'
import { ReactNode, useEffect, useState } from 'react'
import LoadingAnimation from '../LoadingAnimation'
import AdsBanner from 'components/AdsBanner'
import { useConfig } from 'components/providers/ConfigProvider'

const INNER_BASE = 'w-full px-0 md:px-6 lg:px-8 overflow-x-hidden'

interface PageContentProps {
    children: ReactNode
    increaseLeftSidebarWidth?: boolean
}

const PageContent = ({ children, increaseLeftSidebarWidth = false }: PageContentProps) => {
    const config = useConfig()
    const pathname = usePathname()
    const [isReady, setIsReady] = useState(false)
    const isAdminPagesPage = pathname.includes('/admin/pages')

    const layoutClasses = cn(
        'w-full min-h-[calc(100vh-110px)] pb-20 lg:pb-5 overflow-x-hidden',
        'lg:pl-[280px]',
        increaseLeftSidebarWidth && 'lg:pl-[320px]'
    )

    const innerClasses = cn(INNER_BASE, isAdminPagesPage ? 'max-w-[1600px]' : 'max-w-screen-xl')

    useEffect(() => {
        const t = setTimeout(() => setIsReady(true), 100)
        return () => clearTimeout(t)
    }, [pathname])

    if (!isReady && isAdminPagesPage) {
        return (
            <div className={layoutClasses}>
                <div className={innerClasses}>
                    <div className='flex min-h-[12rem] items-center justify-center'>
                        <LoadingAnimation />
                    </div>
                </div>
            </div>
        )
    }

    const adsEnabled = !!(config?.ads_enabled && config?.ads_publisher_id && config?.ads_banner_slot)

    return (
        <div className={layoutClasses}>
            <div className={`${innerClasses} !mx-auto grid px-4 md:px-0`}>
                {adsEnabled && (
                    <div className='mb-4 md:-mx-6 lg:-mx-8'>
                        <AdsBanner
                            adsEnabled={adsEnabled}
                            publisherId={config?.ads_publisher_id ?? null}
                            adSlot={config?.ads_banner_slot ?? null}
                        />
                    </div>
                )}
                {children}
            </div>
        </div>
    )
}

export default PageContent
